var map = {
	"./android.svg": "9a2d",
	"./iPhone.svg": "21c4",
	"./linux.svg": "b0dd",
	"./mac.svg": "d1cf",
	"./pad.svg": "a1b4",
	"./web.svg": "2791",
	"./windows.svg": "b087"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7891";